var PREMIOTT_SLOTS = ['date', 'dial', 'logo', 'hands', 'case', 'glass', 'cyclop', 'strap', 'bezel'];

class PremiottHero extends HTMLElement {
  connectedCallback() {
    this.models = JSON.parse(this.querySelector('[data-hero-models]').textContent);
    if (!this.models.length) return;
    this.stage = this.querySelector('[data-stage]');
    this.layers = {};
    ['static'].concat(PREMIOTT_SLOTS).forEach((k) => {
      this.layers[k] = this.stage.querySelector('[data-layer="' + k + '"]');
    });
    this.chips = Array.from(this.querySelectorAll('[data-model-chip]'));
    this.current = 0;
    this.interacted = false;
    this.assembled = { 0: true };
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.modelChangedAt = 0;
    this.pulsedModels = {};
    this.ctaWarmed = false;
    this.inView = true;

    if (this.models.length > 1) this.classList.add('premiott-hero--hinting');

    this.chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        this.markInteracted();
        this.premiottHeroSelect(Number(chip.dataset.index));
      });
    });

    var stageLink = this.querySelector('[data-stage-link]');
    if (stageLink) {
      var self = this;
      stageLink.addEventListener('click', function (e) {
        if (self.modelChangedAt && Date.now() - self.modelChangedAt < 500) e.preventDefault();
      });
    }

    this.addEventListener('pointerdown', () => this.stopAutoCycle(), { passive: true });
    this.addEventListener('focusin', () => this.stopAutoCycle());

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.inView = entry.isIntersecting;
          });
        }, { threshold: 0.5 }
      ).observe(this);
    }

    this.initSwipe();
    this.buildDots();
    this.playAssemble(false);
    this.startIdle();
    this.preloadRest();
    this.initQuiz();

    if (!this.reduced && this.models.length > 1) {
      this.autoStartTimer = setTimeout(() => this.startAutoCycle(), 5000);
    }
  }

  markInteracted() {
    this.interacted = true;
    this.stopAutoCycle();
    this.endHint();
  }

  endHint() {
    this.classList.remove('premiott-hero--hinting');
  }

  startAutoCycle() {
    var self = this;
    if (this.interacted || this.reduced) return;
    var advances = 0;
    var maxAdvances = this.models.length - 1;
    this.autoTimer = setInterval(function () {
      if (self.interacted) { self.stopAutoCycle(); return; }
      if (document.hidden || !self.inView) return;
      if (advances >= maxAdvances) {
        self.stopAutoCycle();
        self.endHint();
        return;
      }
      advances++;
      var next = (self.current + 1) % self.models.length;
      self.assembled[next] = true;
      self.premiottHeroSelect(next);
    }, 7000);
  }

  stopAutoCycle() {
    if (this.autoStartTimer) { clearTimeout(this.autoStartTimer); this.autoStartTimer = null; }
    if (this.autoTimer) { clearInterval(this.autoTimer); this.autoTimer = null; }
  }

  initSwipe() {
    var self = this;
    var startX = 0;
    var startY = 0;
    var tracking = false;
    this.stage.addEventListener('pointerdown', function (e) {
      if (self.models.length < 2) return;
      tracking = true;
      startX = e.clientX;
      startY = e.clientY;
    }, { passive: true });
    this.stage.addEventListener('pointercancel', function () {
      tracking = false;
    }, { passive: true });
    this.stage.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      if (self.models.length < 2) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > 2 * Math.abs(dy)) {
        var n = self.models.length;
        self.markInteracted();
        self.premiottHeroSelect((self.current + (dx < 0 ? 1 : -1) + n) % n);
      }
    }, { passive: true });
  }

  initQuiz() {
    var dialog = this.querySelector('[data-quiz]');
    var opener = this.querySelector('[data-quiz-open]');
    if (!dialog || !opener) return;
    var self = this;
    var picked = { occasion: null, style: null };
    var step1 = dialog.querySelector('[data-quiz-step="1"]');
    var step2 = dialog.querySelector('[data-quiz-step="2"]');

    opener.addEventListener('click', function () {
      self.markInteracted();
      picked.occasion = null;
      picked.style = null;
      step1.hidden = false;
      step2.hidden = true;
      dialog.showModal();
    });

    dialog.querySelectorAll('[data-quiz-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.quizAnswer === '1') {
          picked.occasion = btn.dataset.tag;
          step1.hidden = true;
          step2.hidden = false;
        } else {
          picked.style = btn.dataset.tag;
          dialog.close();
          self.recommend(picked);
        }
      });
    });
  }

  recommend(picked) {
    var best = 0;
    var bestScore = -1;
    this.models.forEach(function (m, i) {
      var score = 0;
      if (m.styleTag && m.styleTag === picked.style) score += 2;
      if (m.occasionTags && m.occasionTags.split(',').map(function (t) { return t.trim(); }).indexOf(picked.occasion) !== -1) score += 1;
      if (score > bestScore) { bestScore = score; best = i; }
    });
    this.premiottHeroSelect(best);
    this.chips.forEach(function (c, i) {
      var badge = c.querySelector('[data-reco-badge]');
      if (badge) badge.hidden = i !== best;
    });
    this.chips[best].scrollIntoView({ block: 'nearest', behavior: this.reduced ? 'auto' : 'smooth' });
  }

  slotSrc(m, slot) {
    if (slot === 'dial') return m.dials.length ? m.dials[0].src : '';
    if (slot === 'bezel') return m.bezels.length ? m.bezels[0].src : '';
    return m[slot] || '';
  }

  premiottHeroSelect(index) {
    var m = this.models[index];
    if (!m) return;
    var self = this;
    this.current = index;
    this.modelChangedAt = Date.now();
    this.chips.forEach(function (c) {
      c.setAttribute('aria-pressed', Number(c.dataset.index) === index ? 'true' : 'false');
    });
    this.querySelector('[data-model-name]').innerHTML =
      this.esc(m.title) + ' · <span>' + this.esc(m.persona) + '</span>';
    this.querySelector('[data-model-tagline]').textContent = m.tagline;
    var cta = this.querySelector('[data-cta]');
    cta.textContent = m.ctaLabel;
    cta.href = m.url;
    var stageLink = this.querySelector('[data-stage-link]');
    if (stageLink) {
      stageLink.href = m.url;
      stageLink.setAttribute('aria-label', m.title);
    }

    var firstView = !this.assembled[index];
    this.assembled[index] = true;
    if (m.dials.length > 0) {
      this.layers.static.hidden = true;
      PREMIOTT_SLOTS.forEach(function (slot) {
        var src = self.slotSrc(m, slot);
        if (src) self.setLayer(slot, src);
        else self.hideLayer(slot);
      });
    } else {
      PREMIOTT_SLOTS.forEach(this.hideLayer.bind(this));
      this.layers.static.src = m.static;
      this.layers.static.hidden = false;
      this.layers.static.style.opacity = 1;
    }
    this.buildDots();
    if (firstView) this.playAssemble(true);
  }

  setLayer(name, src) {
    var img = this.layers[name];
    if (!img) return;
    img.hidden = false;
    img.style.opacity = 1;
    if (img.getAttribute('src') !== src) img.src = src;
  }

  hideLayer(name) {
    if (this.layers[name]) this.layers[name].hidden = true;
  }

  swapLayer(name, src) {
    var img = this.layers[name];
    if (!img) return;
    var self = this;
    var gen = this.current;
    if (this.reduced) { img.src = src; return; }
    img.style.opacity = 0.6;
    var pre = new Image();
    pre.onload = function () {
      if (self.current !== gen) return;
      img.src = src;
      img.style.opacity = 1;
    };
    pre.onerror = function () {
      if (self.current !== gen) return;
      img.style.opacity = 1;
    };
    pre.src = src;
  }

  buildDots() {
    var m = this.models[this.current];
    var self = this;
    [['dial', m.dials], ['bezel', m.bezels]].forEach(function (pair) {
      var name = pair[0], list = pair[1];
      var group = self.querySelector('[data-swatch-group="' + name + '"]');
      var wrap = self.querySelector('[data-dots="' + name + '"]');
      var labelEl = group.querySelector('.premiott-hero__swatch-label');
      var label = labelEl ? labelEl.textContent : name;
      wrap.innerHTML = '';
      group.hidden = list.length < 2;
      list.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'premiott-hero__dot';
        b.style.background = item.color || 'rgba(128,128,128,0.5)';
        b.setAttribute('data-swatch', '');
        b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        b.setAttribute('aria-label', label + ' ' + (i + 1));
        b.addEventListener('click', function () {
          self.markInteracted();
          wrap.querySelectorAll('.premiott-hero__dot').forEach(function (d) { d.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          self.swapLayer(name, item.src);
          self.warmCta();
        });
        wrap.appendChild(b);
      });
    });
    this.pulseDots();
  }

  pulseDots() {
    if (this.reduced || this.pulsedModels[this.current]) return;
    this.pulsedModels[this.current] = true;
    var wrap = this.querySelector('[data-dots="dial"]');
    var group = this.querySelector('[data-swatch-group="dial"]');
    if (!wrap || !group || group.hidden) return;
    clearTimeout(this.pulseTimer);
    setTimeout(function () {
      wrap.classList.add('premiott-hero__dots--pulse');
    }, 600);
    this.pulseTimer = setTimeout(function () {
      wrap.classList.remove('premiott-hero__dots--pulse');
    }, 3800);
  }

  warmCta() {
    if (this.ctaWarmed) return;
    this.ctaWarmed = true;
    var cta = this.querySelector('[data-cta]');
    if (!cta) return;
    cta.classList.add('premiott-hero__cta--warm');
    setTimeout(function () {
      cta.classList.remove('premiott-hero__cta--warm');
    }, 1200);
  }

  showAllLayers() {
    var self = this;
    ['static'].concat(PREMIOTT_SLOTS).forEach(function (k) {
      var img = self.layers[k];
      if (img && !img.hidden) img.style.opacity = 1;
    });
  }

  playAssemble(replay) {
    var self = this;
    var stage = this.stage;
    clearTimeout(this.assembleTimer);
    if (this.reduced) {
      this.showAllLayers();
      stage.classList.remove('premiott-hero__stage--assemble');
      return;
    }
    if (replay) {
      stage.classList.remove('premiott-hero__stage--assemble');
      ['static'].concat(PREMIOTT_SLOTS).forEach(function (k) {
        var img = self.layers[k];
        if (img && !img.hidden) img.style.opacity = 0;
      });
      void stage.offsetWidth;
      stage.classList.add('premiott-hero__stage--assemble');
    }
    this.assembleTimer = setTimeout(function () {
      self.showAllLayers();
      stage.classList.remove('premiott-hero__stage--assemble');
    }, 4000);
  }

  startIdle() {
    if (this.dataset.enableIdle === 'false') return;
    var self = this;
    var idleIndex = 0;
    setInterval(function () {
      if (self.interacted || document.hidden || self.reduced) return;
      var m = self.models[self.current];
      if (!m || m.dials.length < 2) return;
      idleIndex = (idleIndex + 1) % m.dials.length;
      self.swapLayer('dial', m.dials[idleIndex].src);
      var dots = self.querySelectorAll('[data-dots="dial"] .premiott-hero__dot');
      dots.forEach(function (d, i) { d.setAttribute('aria-pressed', i === idleIndex ? 'true' : 'false'); });
    }, 6000);
  }

  preloadRest() {
    var self = this;
    var models = this.models;
    var run = function () {
      models.forEach(function (m, i) {
        if (i === 0) return;
        var srcs = [m.static];
        PREMIOTT_SLOTS.forEach(function (slot) { srcs.push(self.slotSrc(m, slot)); });
        m.dials.forEach(function (d) { srcs.push(d.src); });
        m.bezels.forEach(function (b) { srcs.push(b.src); });
        srcs.forEach(function (src) { if (src) new Image().src = src; });
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 4000 });
    else setTimeout(run, 2500);
  }

  esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }
}
customElements.define('premiott-hero', PremiottHero);
